import { useCallback, useEffect, useState } from "react";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { signOut } from "redux/sagas/Auth";
import ExampleService from "services/ExampleService";
import useRefState from "utils/use-ref-state";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Input, Modal, Row } from "antd";
import general from "constants/general";

const LoadApp = () => {
  const [system, setSystem] = useState(null);
  const [firstLoginChange, setFirstLoginChange] = useState(false);
  const [formProps, formPropsRef, setFormProps] = useRefState({});
  const updateFormProps = useCallback(
    (vals) => setFormProps((curr) => ({ ...curr, ...vals })),
    []
  );
  useEffect(() => {
    ExampleService.getPost("Settings", null)
      .then((resp) => {
        setSystem(resp.data);
        localStorage.setItem("settings", JSON.stringify(resp.data));
      })
      .catch((e) => {
        if (e) console.log(e);
      });

    const jwtToken = localStorage.getItem(AUTH_TOKEN);
    if (!general.isNullOrEmpty(jwtToken)) {
      ExampleService.getPost("auth/userinfo", null)
        .then((resp) => {
          localStorage.setItem("userinfo", JSON.stringify(resp.data?.user));
          setTimeout(() => {
            setFirstLoginChange(resp.data?.user?.firstLoginChange);
          }, 1000);
        })
        .catch((e) => {
         if (e?.response?.status === 401) {
            localStorage.removeItem(AUTH_TOKEN);
            localStorage.removeItem("userinfo");
            localStorage.removeItem("loginRefresh");
            window.location.href = "/auth/login";
          }
          if (e) console.log(e);
        });
    } else {
      if (window.location?.pathname != "/auth/login") {
        window.location.href = "/auth/login";
      }
    }
    // 🔹 Klavye kısayolları
    const handleKeyPress = (e) => {
      // Ctrl + Shift + K
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "k") {
        e.preventDefault();
        const confirmResult = window.confirm(
          "Bu işlemi yapmak istiyor musunuz?"
        );
        if (confirmResult) secretFunction("CTRL+SHIFT+K");
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, []);

  const secretFunction = (combo) => {
    ExampleService.setEdit("Settings/updateSystemState", {})
      .then((resp) => {
        window.location.reload();
      })
      .catch((e) => {
        if (e) console.log(e);
      });
  };

  const changeLogin = () => {
    ExampleService.setEdit("User/update/login", {
      username: formPropsRef?.current?.username,
      password: formPropsRef?.current?.password,
    })
      .then((resp) => {
        localStorage.removeItem("authority");
        localStorage.removeItem("userinfo");
        localStorage.removeItem(AUTH_TOKEN);
        signOut();
        setTimeout(() => {
          window.location.href = "/auth/login";
        }, 300);
      })
      .catch((e) => {
        if (e) console.log(e);
      });
  };

  const handleChange = useCallback((value) => {
    if (value) updateFormProps({ [value.target.name]: value.target.value });
  }, []);

  if (system?.disabledSystem) {
    return (
      <div
        style={{
          textAlign: "center",
          position: "absolute",
          top: 0,
          left: 0,
          background: "#fff",
          width: "100%",
          height: "100%",
          zIndex: 9999,
          paddingTop: "21%",
        }}
      >
        <h1>SİSTEM YAPIM AŞAMASINDA</h1>
        <p>Bu süre zarfında siteye erişim sağlanamamaktadır.</p>
      </div>
    );
  }
  if (firstLoginChange) {
    return (
      <Modal
        title={"Zorunlu Giriş Bilgileri Değişikliği"}
        visible={true}
        onOk={changeLogin}
        cancelButtonProps={{ className: "divHide" }}
        okText={formProps.id == null ? "Kaydet" : "Güncelle"}
        onCancel={() => {}}
      >
        <Row className="mt-3">
          <label>Kullanıcı Adı</label>
          <Input
            size="default"
            className="mt-2"
            autoComplete="off"
            name="username"
            value={formProps.username}
            onChange={handleChange}
          />
        </Row>
        <Row className="mt-3">
          <label>Şifre</label>
          <Input.Password
            className="mt-2"
            size="default"
            autoComplete="new-password"
            name="password"
            value={formProps?.password}
            onChange={handleChange}
            iconRender={(visible) =>
              visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
            }
          />
        </Row>
      </Modal>
    );
  }
  return null;
};

export default LoadApp;
